// extracted by mini-css-extract-plugin
export default {"cta":"UF-z","disabled":"VF-z"};